import { Redirect, useHistory } from "react-router";
import { Button } from "../../components/button/button";
import SubscriptionLinksList from "../../components/subscription-links/subscription-link-list";
import { useAuthState } from "../../utilities/contexts/auth-state-context";
import { PlanType } from "../../models/enumerations/plan-type";
import { useTranslation } from 'react-i18next';

const COMPONENT_CLASS = "c-lead-links-list";

const SubscriptionLinksPage: React.FC = () => {
    const { state } = useAuthState();
    const history = useHistory();
    const { t } = useTranslation();

    if (!state.user) {
        throw new Error("You must be a super admin");
    }

    const handleAddLink = () => {
        history.push('/subscription-link');
    }

    if (state.organization.plan?.value !== PlanType.ThirdParty || !state.user.isSuperAdmin) {
        return <Redirect to="/" />
    }

    return (
        <>
            <div className={`${COMPONENT_CLASS}`} data-testid={'subscription-links-list'}>
                <div className={`${COMPONENT_CLASS}__header`}>
                    <h1>{t('subscriptionLinks.title')}</h1>
                    <div className={`${COMPONENT_CLASS}__actions`}>
                        <Button
                            type="default"
                            buttonText={t('buttons.btn_addSubscriptionLink')}
                            onClick={handleAddLink}
                        />
                    </div>
                </div>

                <SubscriptionLinksList />

            </div>
        </>
    );
}

export default SubscriptionLinksPage;
